import { useApply } from "../../context/ApplyContext";
import { useT } from "../../i18n";

/**
 * ApplyCTA — single source of truth for every "Apply" call-to-action.
 * Default: brand-styled button (primary | ghost | link)
 * Applied state: non-interactive "Application under review" pill.
 */
export const ApplyCTA = ({
  variant = "primary",
  children,
  appliedLabel,
  testId,
  className = "",
  withArrow = true,
}) => {
  const { open, hasApplied } = useApply();
  const t = useT();
  const label = appliedLabel || t.applyCTA.applied;

  if (hasApplied) {
    if (variant === "link") {
      return (
        <span
          className={`sp-cta-pill sp-cta-pill--link ${className}`}
          data-testid={`${testId}-applied`}
          aria-live="polite"
        >
          <span className="sp-cta-pill-dot" aria-hidden="true" />
          {label}
        </span>
      );
    }
    return (
      <span
        className={`sp-cta-pill ${className}`}
        data-testid={`${testId}-applied`}
        aria-live="polite"
      >
        <span className="sp-cta-pill-dot" aria-hidden="true" />
        {label}
      </span>
    );
  }

  const cls =
    variant === "link"
      ? `sp-underline sp-link-button ${className}`
      : `sp-btn ${variant === "ghost" ? "sp-btn-ghost" : "sp-btn-primary"} ${className}`;

  return (
    <button
      type="button"
      className={cls}
      onClick={open}
      data-testid={testId}
    >
      {children}
      {withArrow && variant !== "link" && <span className="arrow">→</span>}
    </button>
  );
};
